import React, { useEffect, useState, useRef } from 'react';
import { authManager } from '../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const Category_Mapping = () => {
    const [affiliatePlatform, setAffiliatePlatform] = useState('');
    const [brandList, setBrandList] = useState([]);
    const [selectedBrandId, setSelectedBrandId] = useState('');
    const [productCount, setProductCount] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pendingPage, setPendingPage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchBrands = async () => {
            if (!affiliatePlatform) return;

            try {
                const response = await authManager.authenticatedFetch(
                    `${process.env.REACT_APP_API_BASE_URL}/shopping/brands/admin/list?page=1&limit=100&network=${affiliatePlatform}`
                );

                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const data = await response.json();
                setBrandList(data?.result?.brands || []);
                setSelectedBrandId('');
                setProductCount(null);
            } catch (error) {
                console.error('Brand fetch error:', error);
            }
        };

        fetchBrands();
    }, [affiliatePlatform]);

    useEffect(() => {
        const fetchBrandDetails = async () => {
            if (!selectedBrandId) return;

            try {
                const response = await authManager.authenticatedFetch(
                    `${process.env.REACT_APP_API_BASE_URL}/shopping/brands/${selectedBrandId}`
                );

                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const data = await response.json();
                setProductCount(data?.result?.emptyCategoriesCount || 0);
            } catch (error) {
                console.error('Brand detail fetch error:', error);
            }
        };

        fetchBrandDetails();
    }, [selectedBrandId]);

    const getPageNumbers = (totalPages, currentPage) => {
        const pageNumbers = [];
        const maxVisible = 3;

        pageNumbers.push(1);
        if (currentPage > maxVisible + 1) {
            pageNumbers.push('...');
        }

        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            if (i > 1 && i < totalPages) {
                pageNumbers.push(i);
            }
        }

        if (currentPage < totalPages - maxVisible) {
            pageNumbers.push('...');
        }

        if (totalPages > 1) {
            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    const openModal = (page) => {
        setPendingPage(page);
        setShowModal(true);

        if (modalRef.current && window.$) {
            window.$(modalRef.current).modal('show');
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setPendingPage(null);

        if (modalRef.current && window.$) {
            window.$(modalRef.current).modal('hide');
        }
    };


    const handlePageClick = async (page) => {
        setIsLoading(true);
        setCurrentPage(page);

        try {
            const response = await authManager.authenticatedFetch(
                `${process.env.REACT_APP_API_BASE_URL}/shopping/products/categorize-by-brand`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        brandId: selectedBrandId,
                        page,
                        limit: pageSize,
                    }),
                }
            );

            if (!response.ok) throw new Error(`HTTP ${response.status}`);


            toast.success(`Page ${page} mapped successfully`);

            const brandDetailsResponse = await authManager.authenticatedFetch(
                `${process.env.REACT_APP_API_BASE_URL}/shopping/brands/${selectedBrandId}`
            );
            if (!brandDetailsResponse.ok) throw new Error('Brand fetch failed');

            const brandDetails = await brandDetailsResponse.json();
            setProductCount(brandDetails?.result?.emptyCategoriesCount || 0);

            closeModal();


        } catch (error) {
            toast.error('Failed to map products');
            console.error('Error:', error);
        } finally {
            setPendingPage(null);
            setIsLoading(false);  
        }
    };



    return (
        <div>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Category Mapping</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    <form className="form-horizontal">
                                        <div className="card-body">
                                            <div className="form-group row">
                                                <label className="col-12 col-md-4 col-form-label">Affiliate Platforms</label>
                                                <div className="col-12 col-md-8">
                                                    <select
                                                        className="form-control"
                                                        value={affiliatePlatform}
                                                        onChange={(e) => setAffiliatePlatform(e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="CJ">CJ</option>
                                                        <option value="IMPACT">Impact</option>
                                                        <option value="Rakuten">Rakuten</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-12 col-md-4 col-form-label">Brand</label>
                                                <div className="col-12 col-md-8">
                                                    <select
                                                        className="form-control select2"
                                                        value={selectedBrandId}
                                                        onChange={(e) => setSelectedBrandId(e.target.value)}
                                                        disabled={!brandList.length}
                                                    >
                                                        <option value="">Select</option>
                                                        {brandList.map((brand) => (
                                                            <option key={brand._id} value={brand._id}>
                                                                {brand.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {productCount !== null && (
                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">Category Mapping</label>
                                                    <div className="col-12 col-md-8">
                                                        <div className="pt-2">
                                                            You have <b>{productCount}</b> products to be mapped to category
                                                        </div>
                                                        <div className="mt-3">
                                                            <select
                                                                className="form-control"
                                                                value={pageSize}
                                                                onChange={(e) => {
                                                                    const selectedSize = parseInt(e.target.value);
                                                                    setPageSize(selectedSize);
                                                                    setCurrentPage(1);
                                                                }}
                                                            >
                                                                <option value="10">10</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                                <option value="200">200</option>
                                                                <option value="500">500</option>
                                                            </select>

                                                        </div>
                                                        <div className="mt-4">
                                                            <div className="f_sz14 mb-3 fwt_500 f_blue">
                                                                Click on the page count to be mapped
                                                            </div>
                                                            <nav className="categorymapping_page">
                                                                <ul className="pagination">
                                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                        <div className="page-link crsr_pntr" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                                                            «
                                                                        </div>
                                                                    </li>

                                                                    {getPageNumbers(Math.ceil(productCount / pageSize), currentPage).map((page, idx) => (
                                                                        <li
                                                                            key={idx}
                                                                            className={`page-item ${currentPage === page ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}
                                                                        >
                                                                            {page === '...' ? (
                                                                                <span className="page-link">...</span>
                                                                            ) : (
                                                                                <div
                                                                                    className="page-link crsr_pntr"
                                                                                    onClick={() => openModal(page)}
                                                                                >
                                                                                    {page}
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    ))}


                                                                    <li className={`page-item ${currentPage === Math.ceil(productCount / pageSize) ? 'disabled' : ''}`}>
                                                                        <div className="page-link crsr_pntr" onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(productCount / pageSize)))}>
                                                                            »
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </nav>
                                                        </div>

                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`modal fade ${showModal ? 'show' : ''}`} id="modalconfirmmapping" tabIndex={-1} aria-labelledby="modalconfirmmappingLabel" aria-hidden={!showModal} data-backdrop="static" ref={modalRef} style={{ display: showModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalconfirmmappingLabel">Category Mapping</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={closeModal} aria-label="Close">
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="w-100 d-inline-block text-center">
                                Are you sure you want to map <br /><span className="fwt_600">Page {pendingPage}</span>?

                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <div
                                className={`btn btn-blue ${isLoading ? 'disabled' : ''}`}
                                onClick={() => {
                                    if (!isLoading && pendingPage !== null) {
                                        handlePageClick(pendingPage);
                                    }
                                }}
                            >
                                {isLoading ? (
                                    <span>
                                        <i className="fa fa-spinner fa-spin" /> Mapping...
                                    </span>
                                ) : (
                                    'Yes'
                                )}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Category_Mapping;
